<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-orange-50 p-3 border-1 border-orange-100 border-round-lg">
            <i class="pi pi-directions text-orange-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
          <div *ngIf="selectedTargetNodeId() && previewMessage()" class="flex flex-column gap-3">
              <span class="font-semibold text-900 px-1">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.PREVIEW.MESSAGE_LABEL' | translate }}</span>
              <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
                  <div class="flex align-items-start gap-3">
                      <div class="bg-gray-100 border-round p-2">
                          <i [class]="'pi ' + getNodeIcon(selectedTargetNode()?.type!) + ' text-600'"></i>
                      </div>
                      <div class="flex flex-column gap-2 flex-grow-1">
                          <span class="font-bold text-900">{{ targetNodeCopies()[selectedTargetNodeId()!]?.name }}</span>
                          <div class="p-3 bg-bluegray-50 border-round-lg text-700 line-height-3 text-sm italic">
                              "{{ previewMessage() }}"
                          </div>
                      </div>
                  </div>
              </div>
          </div>

         <div *ngIf="selectedStatuses().length > 0" class="flex flex-column gap-3">
            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-check-circle text-blue-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-2">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUSES_LABEL' | translate
                  }}</span>
                  <div class="flex flex-wrap gap-2">
                     <div
                        *ngFor="let s of selectedStatuses()"
                        class="flex align-items-center gap-2 px-3 py-2 border-round-2xl bg-white border-1 border-200 shadow-sm"
                     >
                        <i [class]="statusOptions[0].icon + ' text-blue-500'" *ngIf="s === 'received'"></i>
                        <i [class]="statusOptions[1].icon + ' text-green-500'" *ngIf="s === 'read'"></i>
                        <i [class]="statusOptions[2].icon + ' text-red-500'" *ngIf="s === 'error'"></i>
                        <span class="text-sm font-medium text-700">
                           {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + s.toUpperCase() | translate }}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>

          <p-messages severity="info" [closable]="false">
              <ng-template pTemplate>
                  <div class="flex flex-row gap-3 py-2 px-1">
                      <i class="pi pi-directions text-2xl"></i>
                      <div class="flex flex-column gap-1">
                     <span class="font-bold">
                        {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.PREVIEW.TITLE' | translate }}
                     </span>
                          <span class="line-height-3" [innerHTML]="previewSummary() || ( 'DATA.MODULES.INSPECTORS.CONDITIONAL.DESCRIPTION' | translate )">
                     </span>
                      </div>
                  </div>
              </ng-template>
          </p-messages>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-5">

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <div class="flex align-items-center gap-2">
                  <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_LABEL' | translate }}</span>
                  <i
                     class="pi pi-question-circle text-500 cursor-help"
                     [pTooltip]="'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_TOOLTIP' | translate"
                     tooltipPosition="top"
                  ></i>
               </div>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_HELP' | translate }}</span>
               <div *ngIf="nodeGoalWarning()" class="mt-2">
                  <span class="text-xs text-orange-600 font-medium italic">
                     <i class="pi pi-exclamation-triangle mr-1"></i>
                     {{ nodeGoalWarning() }}
                  </span>
               </div>
            </div>

            <div class="mt-1" [ngClass]="{ 'opacity-60 pointer-events-none': isNodeGoalDisabled() }">
               <p-dropdown
                  [options]="targetNodeOptions()"
                  [ngModel]="selectedTargetNodeId()"
                  optionValue="id"
                  [showClear]="true"
                  [placeholder]="'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_LABEL' | translate"
                  styleClass="w-full"
                  (onChange)="onTargetNodeSelect($event.value)"
               >
                  <ng-template pTemplate="selectedItem" let-selected>
                     <div *ngIf="selected; else emptySelectedNode" class="flex align-items-center gap-2 w-full">
                        <div class="w-2rem h-2rem border-round bg-blue-50 flex align-items-center justify-content-center flex-shrink-0">
                           <i [class]="'pi ' + getNodeIcon(selected.type) + ' text-blue-700'"></i>
                        </div>
                        <div class="flex flex-column overflow-hidden">
                           <span class="font-semibold text-sm text-900 truncate">
                              {{ targetNodeCopies()[selected.id]?.name || getNodeTypeLabel(selected.type) }}
                           </span>
                           <span class="text-xs text-500 truncate" *ngIf="targetNodeCopies()[selected.id]?.alias">
                              {{ targetNodeCopies()[selected.id]?.alias }}
                           </span>
                        </div>
                     </div>
                  </ng-template>

                  <ng-template pTemplate="item" let-option>
                     <div class="flex flex-column gap-2 py-1">
                        <div class="flex align-items-start gap-2">
                           <div class="w-2rem h-2rem border-round bg-bluegray-50 flex align-items-center justify-content-center flex-shrink-0">
                              <i [class]="'pi ' + getNodeIcon(option.type) + ' text-600'"></i>
                           </div>
                           <div class="flex flex-column overflow-hidden flex-grow-1">
                              <div class="flex align-items-center gap-2 w-full">
                                 <span class="font-semibold text-sm text-900 truncate">
                                    {{ targetNodeCopies()[option.id]?.name || getNodeTypeLabel(option.type) }}
                                 </span>
                                 <span class="text-xs px-2 py-1 border-round bg-blue-50 text-blue-700 border-1 border-blue-100 flex-shrink-0">
                                    {{ getNodeTypeLabel(option.type) }}
                                 </span>
                              </div>
                              <span class="text-xs text-500 truncate" *ngIf="targetNodeCopies()[option.id]?.alias">
                                 {{ targetNodeCopies()[option.id]?.alias }}
                              </span>
                              <span class="text-xs text-400 truncate">{{ option.id }}</span>
                              <span class="text-xs text-600 line-height-3 mt-1" *ngIf="getNodeMessagePreview(option.id) as nodeMessagePreview">
                                 "{{ nodeMessagePreview }}"
                              </span>
                           </div>
                        </div>
                     </div>
                  </ng-template>
               </p-dropdown>

               <ng-template #emptySelectedNode>
                  <span class="text-sm text-500">
                     {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.TARGET_NODE_LABEL' | translate }}
                  </span>
               </ng-template>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUSES_LABEL' | translate }}</span>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUSES_HELP' | translate }}</span>
            </div>

            <div class="flex flex-column gap-2 mt-1">
               <div *ngFor="let status of statusOptions" class="w-full">
                  <div
                     class="cursor-pointer p-3 border-1 border-round-xl flex align-items-center justify-content-between gap-3 transition-all transition-duration-200"
                     [ngClass]="selectedStatuses().includes(status.value) ? status.bgColor + ' ' + status.borderColor + ' border-blue-500 shadow-1' : 'bg-white border-200 hover:border-blue-300'"
                     (click)="onStatusToggle(status.value)"
                  >
                     <div class="flex align-items-center gap-3">
                        <div
                           class="w-2rem h-2rem border-round flex align-items-center justify-content-center"
                           [ngClass]="selectedStatuses().includes(status.value) ? status.bgColor : 'bg-gray-100'"
                        >
                           <i [class]="status.icon + ' text-lg ' + (selectedStatuses().includes(status.value) ? status.color : 'text-400')"></i>
                        </div>
                        <div class="flex flex-column">
                           <span class="text-sm font-semibold" [ngClass]="selectedStatuses().includes(status.value) ? 'text-900' : 'text-500'">
                              {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + status.label.toUpperCase() | translate }}
                           </span>
                           <span class="text-xs text-500">
                              {{ 'DATA.MODULES.INSPECTORS.CONDITIONAL.CONFIG.STATUS_' + status.label.toUpperCase() + '_DESC' | translate }}
                           </span>
                        </div>
                     </div>
                     <i *ngIf="selectedStatuses().includes(status.value)" class="pi pi-check-circle text-blue-500 font-bold"></i>
                  </div>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <p-messages *ngIf="errors().length > 0" severity="error">
            <ng-template pTemplate="content">
               <div class="flex flex-column gap-1">
                  <div *ngFor="let error of errors()">
                     {{ getErrorMessage(error) }}
                  </div>
               </div>
            </ng-template>
         </p-messages>

      </div>
   </div>
</div>
